export default "/assets/images/dust-video.137ac75742a7e0c1.mp4";